/**
 *
 * Asynchronously loads the component for BonafiedCertificate
 *
 */

import { lazyLoad } from 'controller/utils/loadable';

export const BonafiedCertificate = lazyLoad(
  () => import('./index'),
  module => module.BonafiedCertificate,
);
